import { combineReducers } from "redux";

import Journee from "./les-tabs-ducks/Journee.ducks";
import Identite from "./les-tabs-ducks/Identite.ducks";
import Aliments from "./les-tabs-ducks/Aliments.ducks";
import HistoEvent from "./les-tabs-ducks/HistoEvent.ducks";
import HistoSante from "./les-tabs-ducks/HistoSante.ducks";
import MessagerieFiche from "./les-tabs-ducks/MessagerieFiche.ducks";
import Planning from "./les-tabs-ducks/Planning.ducks";
import Notes from "./les-tabs-ducks/Notes.ducks";
import Documents from "./les-tabs-ducks/Documents.ducks";


export default combineReducers({
  Journee: Journee,
  Identite: Identite,
  Aliments: Aliments,
  HistoEvent: HistoEvent,
  HistoSante: HistoSante,
  MessagerieFiche: MessagerieFiche,
  Planning: Planning,
  Notes: Notes,
  Documents: Documents
});